import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    accounts:                     require('modules/store/accounts').reducer,
    alicloudAccounts:             require('modules/store/alicloudAccounts').reducer,
    alicloudCredentials:          require('modules/store/alicloudCredentials').reducer,
    alicloudServices:             require('modules/store/alicloudServices').reducer,
    awsAccounts:                  require('modules/store/awsAccounts').reducer,
    awsCredentials:               require('modules/store/awsCredentials').reducer,
    awsInstanceTypes:             require('modules/store/awsInstanceTypes').reducer,
    awsProducts:                  require('modules/store/awsProducts').reducer,
    awsRegions:                   require('modules/store/awsRegions').reducer,
    awsServices:                  require('modules/store/awsServices').reducer,
    awsSupport:                   require('modules/store/awsSupport').reducer,
    awsSupportBilling:            require('modules/store/awsSupportBilling').reducer,
    awsSupportComments:           require('modules/store/awsSupportComments').reducer,
    awsSupportStatuses:           require('modules/store/awsSupportStatuses').reducer,
    awsSupportTechnical:          require('modules/store/awsSupportTechnical').reducer,
    azureAccounts:                require('modules/store/azureAccounts').reducer,
    azureCredentials:             require('modules/store/azureCredentials').reducer,
    azrServices:                  require('modules/store/azrServices').reducer,
    azrRegions:                   require('modules/store/azrRegions').reducer,
    backupsDaily:                 require('modules/store/backupsDaily').reducer,
    backupsHosts:                 require('modules/store/backupsHosts').reducer,
    billingAlerts:                require('modules/store/billingAlerts').reducer,
    billingAlertsStates:          require('modules/store/billingAlertsStates').reducer,
    billingAlertsTypes:           require('modules/store/billingAlertsTypes').reducer,
    categoriesAwsSupport:         require('modules/store/categoriesAwsSupport').reducer,
    consolidateLastRun:           require('modules/store/consolidateLastRun').reducer,
    costCenters:                  require('modules/store/costCenters').reducer,
    cloudBillingAccounts:         require('modules/store/cloudBillingAccounts').reducer,
    cloudBillingProjects:         require('modules/store/cloudBillingProjects').reducer,
    cloudBillingRegions:          require('modules/store/cloudBillingRegions').reducer,
    cloudBillingServices:         require('modules/store/cloudBillingServices').reducer,
    cloudBillingVendors:          require('modules/store/cloudBillingVendors').reducer,
    cloudBillingEntities:         require('modules/store/cloudBillingEntities').reducer,
    cloudBillingResume:           require('modules/store/cloudBillingResume').reducer,
    cloudBillingSpending:         require('modules/store/cloudBillingSpending').reducer,
    CMDBGlobalCake:               require('modules/store/CMDBGlobalCake').reducer,
    CMDBGlobalLast13Months:       require('modules/store/CMDBGlobalLast13Months').reducer,
    CMDBBackupCake:               require('modules/store/CMDBBackupCake').reducer,
    CMDBBackupLast13m:            require('modules/store/CMDBBackupLast13m').reducer,
    CMDBMonitoringCake:           require('modules/store/CMDBMonitoringCake').reducer,
    CMDBMonitoringLast13m:        require('modules/store/CMDBMonitoringLast13m').reducer,
    CMDBPatchCake:                require('modules/store/CMDBPatchCake').reducer,
    CMDBPatchLast13m:             require('modules/store/CMDBPatchLast13m').reducer,
    CMDBServiceDetails:           require('modules/store/CMDBServiceDetails').reducer,
    CMDBDeviceDetails:            require('modules/store/CMDBDeviceDetails').reducer,
    entitiesId:                   require('modules/store/entitiesId').reducer,
    googleAccounts:               require('modules/store/googleAccounts').reducer,
    googleServices:               require('modules/store/googleServices').reducer,
    googleCredentials:            require('modules/store/googleCredentials').reducer,
    iaasGlobalInformation:        require('modules/store/iaasGlobalInformation').reducer,
    iaasVirtualMachines:          require('modules/store/iaasVirtualMachines').reducer,
    iaasVCenterResources:         require('modules/store/iaasVCenterResources').reducer,
    iaasVirtualMachinesLast12m:   require('modules/store/iaasVirtualMachinesLast12m').reducer,
    issues:                       require('modules/store/issues').reducer,
    impersonateCustomers:         require('modules/store/impersonateCustomers').reducer,
    impersonateUser:              require('modules/store/impersonateUser').reducer,
    itcRegions:                   require('modules/store/itcRegions').reducer,
    monitoringActiveClosedEvents: require('modules/store/monitoringActiveClosedEvents').reducer,
    monitoringClientsId:          require('modules/store/monitoringClientsId').reducer,
    monitoringObjectsId:          require('modules/store/monitoringObjectsId').reducer,
    monitoringDaysBySeverity:     require('modules/store/monitoringDaysBySeverity').reducer,
    monitoringEvents:             require('modules/store/monitoringEvents').reducer,
    monitoringClientsIdClasses:   require('modules/store/monitoringClientsIdClasses').reducer,
    monitoringAlarms:             require('modules/store/monitoringAlarms').reducer,
    monitoringHost:               require('modules/store/monitoringHost').reducer,
    operationLogs:                require('modules/store/operationLogs').reducer,
    oracleAccounts:               require('modules/store/oracleAccounts').reducer,
    oracleServices:               require('modules/store/oracleServices').reducer,
    oracleCredentials:            require('modules/store/oracleCredentials').reducer,
    regions:                      require('modules/store/regions').reducer,
    reports:                      require('modules/store/reports').reducer,
    reportsDetailed:              require('modules/store/reportsDetailed').reducer,
    reportsP200:                  require('modules/store/reportsP200').reducer,
    reportBackups:                require('modules/store/reportBackups').reducer,
    reportingBackupsHost:         require('modules/store/reportingBackupsHost').reducer,
    reportingLast2MonthsBackups:  require('modules/store/reportingLast2MonthsBackups').reducer,
    reportingLast13MonthsBackups: require('modules/store/reportingLast13MonthsBackups').reducer,
    reservations:                 require('modules/store/reservations').reducer,
    resources:                    require('modules/store/resources').reducer,
    resourcesModal:               require('modules/store/resourcesModal').reducer,
    resourceTypes:                require('modules/store/resourceTypes').reducer,
    securityCredentials:          require('modules/store/securityCredentials').reducer,
    services:                     require('modules/store/services').reducer,
    servicesAwsSupportBilling:    require('modules/store/servicesAwsSupportBilling').reducer,
    servicesAwsSupportTechnical:  require('modules/store/servicesAwsSupportTechnical').reducer,
    servicesOffering:             require('modules/store/servicesOffering').reducer,
    serviceNowCompanies:          require('modules/store/serviceNowCompanies').reducer,
    serviceNowWritePermissions:   require('modules/store/serviceNowWritePermissions').reducer,
    severities:                   require('modules/store/severities').reducer,
    spendingByAccount:            require('modules/store/spendingByAccount').reducer,
    spendingByCostCenter:         require('modules/store/spendingByCostCenter').reducer,
    spendingByProductArea:        require('modules/store/spendingByProductArea').reducer,
    spendingByVendor:             require('modules/store/spendingByVendor').reducer,
    spendingLastYear:             require('modules/store/spendingLastYear').reducer,
    storageOccupancy:             require('modules/store/storageOccupancy').reducer,
    storageAssigned:              require('modules/store/storageAssigned').reducer,
    storageDetail:                require('modules/store/storageDetail').reducer,
    storageVolume:                require('modules/store/storageVolume').reducer,
    subscriptions:                require('modules/store/subscriptions').reducer,
    tasksState:                   require('modules/store/tasksState').reducer,
    tasksTypes:                   require('modules/store/tasksTypes').reducer,
    topByAccount:                 require('modules/store/topByAccount').reducer,
    topByCostCenter:              require('modules/store/topByCostCenter').reducer,
    topByProductArea:             require('modules/store/topByProductArea').reducer,
    totalSpending:                require('modules/store/totalSpending').reducer,
    vcloudAccounts:               require('modules/store/vcloudAccounts').reducer,
    vcloudCredentials:            require('modules/store/vcloudCredentials').reducer,
    vcloudServices:               require('modules/store/vcloudServices').reducer,
    vendors:                      require('modules/store/vendors').reducer,
    vmStates:                     require('modules/store/vmStates').reducer,
    itsmSummaryTickets:           require('modules/store/itsmSummaryTickets').reducer,
    itsmOpenTickets:              require('modules/store/itsmOpenTickets').reducer,
    itsmDetailsTickets:           require('modules/store/itsmDetailsTickets').reducer,
    itsmSummaryTicketsLast12:     require('modules/store/itsmSummaryTicketsLast12').reducer,
    customerProductsDetails:      require('modules/store/customerProductsDetails').reducer,
    objectStorageVolume:          require('modules/store/objectStorageVolume').reducer,
    objectStorageOccupancy:       require('modules/store/objectStorageOccupancy').reducer,
    objectStorageAssigned:        require('modules/store/objectStorageAssigned').reducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/store/index.js